export const VALIDATE_DOMAIN = "VALIDATE_DOMAIN";
export const PUBLISH_NEW_SUBDOMAIN = "PUBLISH_NEW_SUBDOMAIN";
export const LOAD_USER_DOMAIN_INFO = "LOAD_USER_DOMAIN_INFO";
export const RESET_USER_DOMAIN_INFO = "RESET_USER_DOMAIN_INFO"